export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const CHANGE_USER_STATUS_REQUEST = "CHANGE_USER_STATUS_REQUEST";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const FETCH_USER_BOOKINGS_REQUEST = "FETCH_USER_BOOKINGS_REQUEST";
export const FETCH_USER_COMMENTS_REQUEST = "FETCH_USER_COMMENTS_REQUEST";
export const FETCH_USER_FAVORITES_REQUEST = "FETCH_USER_FAVORITES_REQUEST";
export const FETCH_USER_RATINGS_REQUEST = "FETCH_USER_RATINGS_REQUEST";
export const FETCH_USER_WALLET_LIST_REQUEST = "FETCH_USER_WALLET_LIST_REQUEST";
export const UPDATE_USER_WALLET_BALANCE_REQUEST = "UPDATE_USER_WALLET_BALANCE_REQUEST";
export const FETCH_USER_WALLET_LOG_REQUEST = "FETCH_USER_WALLET_LOG_REQUEST";
